import { useEffect, useLayoutEffect, useMemo, useSyncExternalStore } from 'react';
import type { GameReplayStore } from '../stores/game-replay-store';
import {
  ObservationTimelineSession,
  type ObservationTimelineContext,
} from '../stores/observation-timeline-session';

export function useObservationTimeline(
  store: GameReplayStore | undefined,
  context: ObservationTimelineContext | null,
  enabled: boolean,
  { restoreSaved = false }: { readonly restoreSaved?: boolean } = {},
) {
  const session = useMemo(() => new ObservationTimelineSession(store), [store]);
  const state = useSyncExternalStore(session.subscribe, session.snapshot, session.snapshot);
  useLayoutEffect(() => {
    session.setContext(context, enabled, restoreSaved);
  }, [session, context, enabled, restoreSaved]);
  useEffect(() => () => session.stop(), [session]);
  const matching =
    state.context?.gameId === context?.gameId &&
    state.context?.stateVersion === context?.stateVersion &&
    state.context?.configurationKey === context?.configurationKey &&
    state.context?.rulesKey === context?.rulesKey;
  return {
    points: matching ? state.points : [],
    data: matching ? state.data : null,
    error: matching ? state.error : null,
    loading: matching ? state.loading : restoreSaved && context !== null,
    retry: session.retry,
    recordForeground: session.recordForeground,
  };
}
